<template>
  <div class="container-lg">
    <!-- Modal nuevo/editar -->
    <ModalComercio ref="modalComercio" :facade="facade" v-on:cerrado="modalCerrado" v-on:creado="creado"
      v-on:editado="editado" />
    <!--Modal de QR o Logo-->
    <div id="modalInfo" class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-if="!!comercioVisto">
              <span>{{ comercioVisto.name }} - </span>
              <span v-if="modoModalInfo == 'logo'">Logo</span>
              <span v-if="modoModalInfo == 'qrPerfilComercio'">QR Perfil Comercio</span>
              <span v-if="modoModalInfo == 'qrBeneficioComercio'">QR Beneficio Comercio</span>
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- Modo Logo -->
            <vue-load-image v-if="modoModalInfo == 'logo' &&
              !!comercioVisto &&
              !!comercioVisto.logoUrl
              ">
              <!-- Logo -->
              <img slot="image" class="modal-imagen" :src="LogoVisto" alt="Error al cargar logo" />
              <!-- Indicador de carga -->
              <div slot="preloader">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
              <!-- Mensaje de error -->
              <div slot="error">
                <div class="alert alert-danger" role="alert">
                  Ocurrió un error al cargar la imagen
                </div>
              </div>
            </vue-load-image>
            <!-- Modo QR Perfil Comercio -->
            <div class="modal-qr-container" v-if="modoModalInfo == 'qrPerfilComercio' && !!comercioVisto && !!comercioVisto.id
              ">
              <div class="qr-image-container">
                <vue-qrcode :value="UrlComercios + comercioVisto.id" id="qrRoot" width="148" />
              </div>
              <div class="d-flex align-items-center justify-content-center mb-3 gap-2">
                <!-- Label de url -->
                <span>{{ UrlComercios + comercioVisto.id }}</span>

                <!-- Botones de accion -->
                <div class="d-flex gap-2">
                  <button class="btn btn-primary" type="button" v-clipboard:copy="UrlComercios + comercioVisto.id"
                    v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError"
                    v-if="UrlComercios + comercioVisto.id">
                    <font-awesome-icon :icon="Icons.COPIAR" />
                  </button>
                  <button @click="descargarQR()" type="button" class="btn btn-success">
                    <font-awesome-icon :icon="Icons.DESCARGAR" />
                  </button>
                </div>
              </div>

            </div>
            <div v-if="!comercioVisto" class="alert alert-danger" role="alert">
              Error al cargar imágen
            </div>

            <!-- Modo QR Beneficio Comercio -->
            <div class="modal-qr-container"
              v-if="modoModalInfo == 'qrBeneficioComercio' && !!comercioVisto && !!comercioVisto.urlQR">
              <div class="qr-image-container">
                <vue-qrcode :value="comercioVisto.urlQR" id="qrRoot" width="148" />
              </div>

              <div class="d-flex align-items-center justify-content-center mb-3 gap-2">
                <!-- label de url -->
                <span>{{ comercioVisto.urlQR }}</span>

                <!-- botones de acciones -->
                <div class="d-flex gap-2">
                  <button class="btn btn-primary" type="button" v-clipboard:copy="comercioVisto.urlQR"
                    v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError" v-if="comercioVisto.urlQR">
                    <font-awesome-icon :icon="Icons.COPIAR" />
                  </button>
                  <button @click="descargarQR()" type="button" class="btn btn-success">
                    <font-awesome-icon :icon="Icons.DESCARGAR" />
                  </button>
                </div>
              </div>

            </div>
            <div v-if="!comercioVisto" class="alert alert-danger" role="alert">
              Error al cargar imágen
            </div>

          </div>
        </div>
      </div>
    </div>
    <div v-show="!cargando">
      <div v-show="cantidad <= 0" class="alert alert-primary info-sin-elementos" role="alert">
        <p class="principal">No se encontraron comercios</p>
        <p v-if="infoSinResultados" class="extra">{{ infoSinResultados }}</p>
      </div>
      <div v-show="cantidad > 0" id="tablaComercios" class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th v-if="MostrarAcciones">Acción</th>
              <th>Nombre</th>
              <th>Teléfono</th>
              <th>Email</th>
              <th>Dirección</th>
              <th>Activo</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="com in lista">
              <tr v-bind:key="com.id" data-toggle="collapse" :data-target="'#fila' + com.id" class="fila-expandible">
                <!-- Acción -->
                <td v-if="MostrarAcciones">
                  <div class="acciones">
                    <!-- Se hace un stopPropagation para que no cierre el comercioVisto -->
                    <button v-if="mostrarEditar" type="button" class="btn btn-warning" v-on:click.stop="clickEditar(com)">
                      <font-awesome-icon :icon="Icons.EDITAR" />
                    </button>
                    <button v-if="mostrarEliminar" type="button" class="btn btn-danger"
                      v-on:click.stop="clickEliminar(com)">
                      <font-awesome-icon :icon="Icons.ELIMINAR" />
                    </button>
                  </div>
                </td>
                <!-- Nombre -->
                <th scope="row">{{ com.name }}</th>
                <!--Telefono -->
                <td>{{ com.phone }}</td>
                <!--WhatsApp -->
                <td>{{ com.whatsapp }}</td>
                <!-- Email -->
                <td>{{ com.email }}</td>
                <!-- Direccion -->
                <td>{{ com.address }}</td>
                <!-- Activo -->
                <td>{{ com.activo ? 'Sí' : 'No' }}</td>
              </tr>
              <!-- Filas expandibles -->
              <tr v-bind:key="'expandible' + com.id" class="collapse" :id="'fila' + com.id">
                <!-- QR Perfil Comercio -->
                <td v-if="com.id">
                  <button type="button" class="btn btn-link" @click="verQRPerfilComercio(com)">
                    <font-awesome-icon :icon="Icons.QR" />
                    QR Perfil Comercio
                  </button>
                </td>
                <!-- Logo -->
                <td v-if="com.logoUrl">
                  <button type="button" class="btn btn-link" @click="verLogo(com)">
                    <font-awesome-icon :icon="Icons.IMAGEN" />
                    Logo
                  </button>
                </td>
                <!-- QR Beneficio Comercio -->
                <td v-if="com.id">
                  <button type="button" class="btn btn-link" @click="verQRBeneficioComercio(com)" v-if="com.urlQR">
                    <font-awesome-icon :icon="Icons.QR" />
                    QR Beneficio Comercio
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <Paginacion ref="paginacion" :cantidad="cantidad" :cantidadPorPagina="CantidadPorPagina" :paginaInicial="pagina"
          v-on:pagina-cambiada="paginaCambiada" />
        <div class="alert alert-secondary alert-dismissible fade show" role="alert">
          Puede ver QR y Logo haciendo click en la fila de cada comercio.
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
    <div v-show="cargando" class="spinner-border" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</template>

<script>
import { environment } from "../../../environments/environment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";
import VueLoadImage from "vue-load-image";
import VueQrcode from "vue-qrcode";

import {
  Carpetas,
  Icons as IconConstants,
  Paginacion as ConstantesPaginacion
} from "../../../constants";
import ModalComercio from "../modals/ModalComercio";
import Paginacion from "../../Paginacion";
import { Util } from "../../../util";

const bootstrap = require("bootstrap");

/** Cuando se empezó a editar */
const EVENTO_EDITAR = "editar";
/** Cuando se terminó de editar */
const EVENTO_EDITADO = "editado";
const EVENTO_ELIMINADO = "eliminado";

const COMERCIO_LIMPIO = {
  id: "",
  activo: null,
  nombre: "",
  direccion: "",
  telefono: "",
  whatsapp: "",
  cuit: "",
  email: "",
  observaciones: "",
  localidad: {
    id: "",
    nombre: ""
  },
  urlQR: ""
};

export default {
  components: {
    FontAwesomeIcon,
    VueLoadImage,
    VueQrcode,

    ModalComercio,
    Paginacion
  },
  props: {
    busqueda: Object,
    // Si está en verdadero, no se realizarán cargas automáticas
    // Ejemplo en el mounted hook o cuando cambia la búsqueda
    cargaManual: Boolean,
    facade: Function,
    // Información extra mostrada cuando no se encontraron resultados
    infoSinResultados: String,
    // Mostrar u ocultar acciones
    mostrarEditar: Boolean,
    mostrarEliminar: Boolean
  },
  data() {
    return {
      cantidad: 0,
      cargando: true,
      /**Comercio que está siendo visto */
      comercioVisto: Util.copiaProfunda(COMERCIO_LIMPIO),
      lista: [],
      /**Modal para mostrar logos y QR */
      modalInfo: null,
      /**Usado para alternar el modal entre QR y logo */
      modoModalInfo: "",
      pagina: 1,
    };
  },
  computed: {
    CantidadPorPagina() {
      return ConstantesPaginacion.COMERCIOS_POR_PAGINA;
    },
    /**Dirección de la carpeta de logos */
    CarpetaLogos() {
      return environment.API_URL + Carpetas.LOGOS;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    /** Logo visto en el modal */
    LogoVisto() {
      return this.CarpetaLogos + this.comercioVisto.logoUrl;
    },
    MostrarAcciones() {
      return this.mostrarEditar || this.mostrarEliminar;
    },
    UrlComercios() {
      return environment.URL_COMERCIOS_QR;
    }
  },
  watch: {
    busqueda() {
      if (!this.cargaManual) this.recargar();
    }
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    // Cuando se quiere crear un nuevo elemento
    EventoCrear() {
      this.$refs.modalComercio.EventoAbrir();
    },
    EventoRecargar(busqueda) {
      this.recargar(busqueda);
    },

    // ----------------   Metodos privados  --------------
    cargar(busqueda = this.busqueda) {
      this.cargando = true;
      // Parámetros de paginación
      const desde = Util.paginacionCalcularDesde(
        this.pagina,
        this.CantidadPorPagina
      );
      const hasta = Util.paginacionCalcularHasta(
        this.pagina,
        this.CantidadPorPagina
      );

      this.facade
        .getListWithFilter({
          pagination: {
            desde,
            hasta
          },
          search: busqueda
        })
        .then(response => {
          this.lista = response.data;
          this.cargando = false;
        });
    },
    clickEditar(lightItem) {
      this.facade.getById(lightItem.id).then(response => {
        const fullItem = response.data;

        // Abrir modal de edición
        this.$refs.modalComercio.EventoAbrir(fullItem);

        // Informar que se empezó a editar
        this.$emit(EVENTO_EDITAR, fullItem);
      });
    },
    clickEliminar(item) {
      Swal.fire({
        title: "Atención!",
        text: "Seguro que desea eliminar este comercio? Esto implica el borrado de TODOS los datos asociados al mismo.",
        icon: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "No",
        preConfirm: () => {
          return this.facade
            .delete(item.id)
            .then(() => {
              this.eliminado(item);
            })
            .catch(() => {
              Swal.showValidationMessage(
                "Ocurrió un error al tratar de eliminar el comercio. Si el error persiste consulte al administrador del sistema."
              );
            });
        }
      }).then(result => {
        // Si confirma
        if (result.isConfirmed) {
          Swal.fire("Confirmación", "El comercio ha sido eliminado", "success");
        }
      });
    },
    // Cuando un item fue creado
    creado(item) {
      console.log("item creado: " + item);

      this.cantidad++;
      this.cargar();
    },
    /**Descarga el QR del perfil de comercio actual */
    descargarQR() {
      // Obtener el link de la imagen temporal generada por el componente de QR
      const imageLink = document.getElementById("qrRoot").src;

      // Crear un elemento temporal <a> para poder descargar
      let a = document.createElement("a");
      a.href = imageLink;

      if (this.modoModalInfo == "qrPerfilComercio") {
        // Nombre del archivo descargado
        a.download = this.comercioVisto.id + "_" + this.comercioVisto.name.replace(/\s/g, "") + "_QR_Perfil" + ".png";
      }

      if (this.modoModalInfo == "qrBeneficioComercio") {
        // Nombre del archivo descargado
        a.download = this.comercioVisto.id + "_" + this.comercioVisto.name.replace(/\s/g, "") + "_QR_Beneficio" + ".png";
      }

      document.body.appendChild(a);

      // Simular un click para descargar
      a.click();

      // Eliminar elemento temporal
      document.body.removeChild(a);
    },
    // Cuando se guardó la edición de un item
    editado(item) {
      // Si justo se editó el logo del comercio visto
      if (this.comercioVisto && this.comercioVisto.id == item.id) {
        // Guardar el nuevo nombre de logo para que pueda
        // ser consultado
        this.comercioVisto.logoUrl = item.logoUrl;
      }

      // TODO: solo cargar cuando el item queda fuera de la página
      this.cargar();

      // Avisar que se editó un item
      this.$emit(EVENTO_EDITADO, item);
    },
    eliminado(item) {
      this.$emit(EVENTO_ELIMINADO, item);
      this.cantidad--;

      // TODO: en vez de cargar todos, pedir solo uno para agregar a la lista
      this.cargar();
    },
    // Cuando se cierra el modal de creación/edición
    modalCerrado() { },
    recargar(busqueda = this.busqueda) {
      this.cargando = true;
      this.pagina = 1;
      this.lista = [];

      this.facade.countWithFilter({ search: busqueda }).then(respuesta => {
        this.cantidad = respuesta.data;

        if (this.cantidad > 0) {
          this.cargar(busqueda);
        } else {
          this.cargando = false;
        }
      });
    },
    paginaCambiada(numero) {
      this.pagina = numero;
      this.cargar();
      // Scrollear hacia arriba de la tabla
      Util.scrollearAId("tablaComercios", true);
    },
    verLogo(comercio) {
      this.comercioVisto = comercio;
      this.modoModalInfo = "logo";
      this.modalInfo.show();
    },
    /**Muestra modal con el QR del comercio */
    verQRPerfilComercio(comercio) {
      this.comercioVisto = comercio;
      this.modoModalInfo = "qrPerfilComercio";
      this.modalInfo.show();
    },
    /**Muestra modal con el QR del beneficio del comercio */
    verQRBeneficioComercio(comercio) {
      this.comercioVisto = comercio;
      this.modoModalInfo = "qrBeneficioComercio";
      this.modalInfo.show();
    },
    // Alerta para mostrar que se copio al portapapeles
    onCopySuccess() {
      return Swal.fire({
        icon: "success",
        title: "Copiado al portapeles",
        timer: 2000,
        showConfirmButton: false,
      });

    },

    // Alerta para mostrar que no se copio al portapapeles, error
    onCopyError() {
      return Swal.fire({
        icon: "error",
        title: "Ocurrió un error al copiar",
        timer: 2000,
        showConfirmButton: false,
      });

    },

    verificarUrlQR() {

    }
  },
  mounted() {
    const opcionesModal = {};
    this.modalInfo = new bootstrap.Modal(
      document.getElementById("modalInfo"),
      opcionesModal
    );

    if (!this.cargaManual) this.recargar();
  }
};
</script>

<style lang="scss" scoped>
.qr-image-container {
  img {
    width: 30vw;
    max-width: 400px;
    min-width: 250px;
  }
}

.modal-imagen {
  max-width: 100%;
  max-height: 100%;
}

.modal-qr-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.modal-qr-container button {
  margin-left: auto;
  margin-right: auto;
}

.fila-expandible{
  td, th{
    vertical-align: middle;
  }
}
</style>
